export const iconFontAwesomeUsersPeoplePersonBooth = (
	<i className="fa-solid fa-person-booth"></i>
);
